import React, {useState, useEffect} from 'react';
import styles from './index.module.scss';

// componentes
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import BotaoTabela from './../../../Componentes/BotaoTabela';
import { Badge } from 'react-bootstrap';

// funçõs
import { estiloEvento } from './../../../ConfiguracaoSistema';

// elemento registro
function Registro({
    dados, 
    clicouVer
}){

    let icone = ['far', 'square'];
    if(dados.lido === 'S'){
        icone = ['far', 'check-square'];
    }

    return <tr
        onClick={clicouVer}
        className={`clicavel`}
    >
        <td className="estreito text-center font-weight-bold">{dados.naoLidos}</td>
        <td className="estreito text-center font-weight-bold">{dados.quantidade}</td>
        <td>
            {dados.cartaOferta}
        </td>
        <td>
            {dados.nomeEmpresa}
        </td>
        <td className="text-nowrap estreito">
            {/* <BotaoTabela 
                onClick={clicouEditar}
                icone={["fas", "pencil-alt"]}
            >Editar</BotaoTabela> */}
        </td>
    </tr>
}

export default Registro;